module.exports = __webpack_public_path__ + "img/bootstrap4-light-purple.937a777e.svg";